import type { Role } from '@/entities/user';

/** Home business KPIs: Q-commerce SUPER_ADMIN + WAREHOUSE_MANAGER (API may 403 others). */
export const homeAccessRoles = [
  'admin',
  'warehouse_manager',
  'accountant',
  'finance_admin',
] as const satisfies readonly Role[];
